import { useContext, useEffect, useState } from "react";
import CreateCancelmicro from "../../../../components/forms/CreateCancelmicro";
import TabelProps from "../../../../components/tabel/props/TabelProps";
import DashboardContext from "../../../../Context";
import FormWorkerDocument from "../../workerDocument/FormWorkerDocument";

export default function DocumentWorker() {

    const { showformmicro, sideBardata } = useContext(DashboardContext)

    const [arryactions, setArryactions] = useState([]);

    useEffect(() => {
        if (sideBardata) {
            sideBardata.map(item => {
                item.controllers.filter(find => {
                    if (`/${find.controller}` === '/WorkerDocument') {
                        //console.log(find.actions);
                        setArryactions(find.actions)
                        return find
                    }
                })
            })
        }
        return () => {

        };
    }, []);


    return (
        <>
            <CreateCancelmicro ismicro actions={arryactions} />
            {
                showformmicro ?
                    <FormWorkerDocument urlWebsilte='/workerDocument' />
                    :
                    arryactions.includes('Get') ? <TabelProps urldata='/workerDocument' arryactions={arryactions} accordionTable/> : "شما اجازه دسترسی به این بخش را ندارید :("
            }
        </>

    )
}
